// The "download started" icon (design_handoff_2/Website Modals.dc.html, "1a")
// — the brand success motif noted in design_handoff_2/CLAUDE.md: four
// concentric rings breathing at individual paces around a centre dot that
// idles charcoal and occasionally flashes brick red. Pure CSS (no timers,
// unlike PurchaseSuccessMark) since every ring just loops forever.
export function DownloadStartedMark() {
    return (
        <svg width="56" height="56" viewBox="0 0 56 56" className="animate-badgein" aria-hidden>
            <circle
                cx={28}
                cy={28}
                r={26}
                fill="none"
                stroke="rgba(41, 41, 39, 0.16)"
                strokeWidth={0.8}
                className="origin-center animate-ringbreathe1"
            />
            <circle
                cx={28}
                cy={28}
                r={20}
                fill="none"
                stroke="rgba(41, 41, 39, 0.28)"
                strokeWidth={0.8}
                className="origin-center animate-ringbreathe2"
            />
            <circle
                cx={28}
                cy={28}
                r={14}
                fill="none"
                stroke="rgba(41, 41, 39, 0.4)"
                strokeWidth={0.8}
                className="origin-center animate-ringbreathe3"
            />
            <circle
                cx={28}
                cy={28}
                r={8}
                fill="none"
                stroke="rgba(41, 41, 39, 0.55)"
                strokeWidth={0.8}
                className="origin-center animate-ringbreathe4"
            />
            <circle cx={28} cy={28} r={3} className="animate-dotvisit" />
        </svg>
    );
}

export default DownloadStartedMark;
